import { Month, MONTHS } from 'util/types/months';
import * as z from 'zod';
import { ErrorMessages } from '../error-messages';

export const updateBirthdayFormSchema = z.object({
  month: z.nativeEnum(MONTHS as Record<number, Month>),
  day: z
    .number()
    .min(1, ErrorMessages.Day.INVALID)
    .max(31, ErrorMessages.Day.INVALID)
    .optional()
    .refine(x => !!x, { message: ErrorMessages.Day.INVALID }),
  year: z
    .number()
    .min(1900, ErrorMessages.GradYear.INVALID)
    .max(2100, ErrorMessages.GradYear.INVALID)
    .optional()
    .refine(x => !!x, { message: ErrorMessages.GradYear.INVALID }),
});

export type UpdateBirthdayForm = Required<
  z.TypeOf<typeof updateBirthdayFormSchema>
>;
